import { Link } from 'react-router-dom';
import cn from '../../lib/cn';
import { site } from '../../data/site';

/** Wordmark + mark. `tone="dark"` renders for dark backgrounds. */
export default function Logo({ tone = 'light', className, onClick }) {
  const dark = tone === 'dark';

  return (
    <Link
      to="/"
      onClick={onClick}
      className={cn('group flex items-center gap-2.5', className)}
      aria-label={`${site.name} — home`}
    >
      <span
        className={cn(
          'grid h-10 w-10 flex-none place-items-center overflow-hidden rounded-xl transition-transform duration-300 group-hover:scale-105',
          dark ? 'ring-1 ring-white/20' : 'ring-1 ring-ink-100'
        )}
      >
        <img src={`${process.env.PUBLIC_URL}/logo.jpeg`} alt="" className="h-full w-full object-cover" />
      </span>
      <span className="leading-none">
        <span
          className={cn(
            'block font-display text-lg font-bold tracking-tight',
            dark ? 'text-white' : 'text-ink-900'
          )}
        >
          {site.name}
        </span>
        <span
          className={cn(
            'mt-1 block text-[0.62rem] font-semibold uppercase tracking-[0.18em]',
            dark ? 'text-brand-200/80' : 'text-brand-600'
          )}
        >
          A initative by Nishant Industries Pvt. Ltd.
        </span>
      </span>
    </Link>
  );
}
